import axios from 'axios'
import supplierReport from '@/assets/js/report/supplier_order'
import returnReport from '@/assets/js/report/return_order'
import transferReport from '@/assets/js/report/transfer_order'
import processProductLabels from '@/assets/js/report/supplier_products'
export default {
  methods: {
    async printOrder (item, additionalOps = {}) { // locType - withlocation/without locations
      let includeLocation = additionalOps.withLocs
      let includePrices = additionalOps.withPrices
      this.$_executeApi('post', `file/generate_pdf`, { visiblefilename: `${this.$t('message.warehouse.orderRepo')}_${item.number}`, content: await this.generateReport(item, includeLocation, includePrices) })
        .then((response) => {
          let fileName = response.data
          window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
        })
    },
    async generateReport (payload, includeLocation, withPrices, isShare = false) {
      let customerLang = (payload && payload.supplier_language) ? payload.supplier_language : this.$i18n.locale
      let lang = this.$i18n.messages[customerLang].message
      let headers = [{ text: lang.warehouse.product, value: 'productnumber' },
        { text: lang.whOrder.orderQty, value: 'qty' },
        { text: lang.whOrder.recQty, value: 'receivedqty' },
        { text: lang.order.batchNo, value: 'batchnumber' },
        { text: lang.layout.warehouse, value: 'warehouseid' },
        { text: lang.layout.location, value: 'locationid' },
        { text: lang.common.receivedOn, value: 'receivedon' }
      ]
      let transData = {
        type: lang.product.type,
        number: lang.product.number,
        date: lang.whOrder.orderDate,
        labeled: lang.whOrder.labeled,
        contact: lang.invoice.yourContact,
        requestedDate: lang.whOrder.requested,
        order: lang.common.order_report,
        comments: lang.common.comments,
        warehouse: lang.layout.warehouse,
        sourceWH: lang.whOrder.sourceWH,
        destinationWH: lang.whOrder.destinationWH,
        responsible: lang.deviations.responsible,
        ourContact: lang.whOrder.ourContact,
        supplier: lang.order.supplier,
        total: lang.common.total,
        telephone: lang.invoiceReport.telephone,
        deliveryAddress: lang.orders.deliveryAddress,
        invoiceAddress: lang.orders.invoiceAddress,
        orgNo: lang.invoiceReport.orgNo,
        kilabOrder: lang.orders.salesReference,
        currency: lang.product.currency
      }
      let result = (payload.type_ref === 'supplier') ? await this.getSupplierReport(payload.id, isShare) : await this.getOrderProducts(payload.id, payload.type_ref)
      let content = ''
      switch (payload.type_ref) {
        case 'supplier':
          if (!result) result.data = []
          headers = [{ text: lang.product.number, value: 'productnumber', width: '15%' },
            { text: lang.layout.product, value: 'product', width: '35%' },
            { text: lang.whOrder.loc, value: 'location', width: '7%' },
            { text: lang.order.qty, value: 'qty', width: '5%' },
            { text: lang.product.unit, value: 'unit', width: '5%' },
            { text: lang.orders.price, value: 'price', width: '10%' },
            { text: lang.whOrder.discount, value: 'discount', width: '8%' },
            { text: lang.whOrder.discounted, value: 'discounted', width: '10%' },
            { text: lang.common.total, value: 'total', width: '10%' }
          ]
          var { data } = await this.getGeneralSetting()
          var saleOrder = await this.getSaleOrderData(payload.id)
          if (isShare) {
            // setting current date on the report, it will be saved the db on API
            payload.orderdate = this.$formatter.formatDate(new Date(), 'YYYY-MM-DD', 'DD.MM.YYYY')
          }
          if (saleOrder && saleOrder.data) payload = { ...payload, saleOrderNumber: saleOrder.data.number }
          content = supplierReport(headers, result.data, payload, transData, data, includeLocation, withPrices)
          break
        case 'return':
        case 'adjustment':
          headers = [{ text: lang.warehouse.product, value: 'productnumber' },
            { text: lang.whOrder.orderQty, value: 'qty' },
            { text: lang.order.batchNo, value: 'batchnumber' },
            { text: lang.layout.location, value: 'locationid' }
          ]
          let warehouseid = payload.warehouseid
          let getWarehouse = this.$_findValueInArray(this.listOfWarehouse, x => x.id === warehouseid)
          payload.warehousename = getWarehouse ? getWarehouse.name : ''
          content = returnReport(headers, result, payload, transData)
          break
        case 'transfer':
          let sourceWH = payload.warehouseid
          let destinationWH = payload.destinationwarehouseid
          let getSourceWH = this.$_findValueInArray(this.listOfWarehouse, x => x.id === sourceWH)
          let getDestinationWH = this.$_findValueInArray(this.listOfWarehouse, x => x.id === destinationWH)
          payload.sourceWHName = getSourceWH ? getSourceWH.name : ''
          payload.destinationWHName = getDestinationWH ? getDestinationWH.name : ''
          headers = [{ text: lang.warehouse.product, value: 'productnumber' },
            { text: lang.whOrder.orderQty, value: 'qty' },
            { text: lang.layout.location, value: 'location' },
            { text: lang.whOrder.pickQty, value: 'pickedqty' },
            { text: lang.whOrder.recQty, value: 'receivedqty' },
            { text: lang.order.batchNo, value: 'batchnumber' },
            { text: lang.layout.location, value: 'locationid' },
            { text: lang.common.receivedOn, value: 'receivedon' }
          ]
          content = transferReport(headers, result, payload, transData)
          break
        default:
          break
      }
      return content
    },
    getSupplierReport (id, isShare) {
      return this.$_executeApi('get', `warehouseorderitems/get_by_order_for_report/${id}/${isShare}`)
    },
    getSaleOrderData (id) {
      return this.$_executeApi('get', `warehouseorders/get_sale_order/${id}`)
    },
    getGeneralSetting () {
      return this.$_executeApi('get', 'commonsettings')
    },
    getOrderProducts (id, type) {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `warehouseorderitems/get_by_order/${id}`)
          .then((response) => {
            if (response.data) {
              let result = response.data
              for (let i = 0; i < result.length; i++) {
                result[i].qty = this.$formatter.replaceDotWithCommaIfHasDecimal(result[i].qty)
                for (let j = 0; j < result[i].receivedorders.length; j++) {
                  if (!result[i].pickedorders[j]) result[i].pickedorders[j] = {}
                  result[i].receivedorders[j].receivedqty = this.$formatter.replaceDotWithComma(result[i].receivedorders[j].receivedqty)
                  // let locationid = result[i].receivedorders[j].locationid
                  // let destLocationId = result[i].pickedorders[j] ? result[i].pickedorders[j].locationid : 0
                  let warehouseid = result[i].receivedorders[j].warehouseid
                  // let getLocation = this.$_findValueInArray(this.listOfLocations || [], x => x.id === locationid)
                  // let getDesLocation = this.$_findValueInArray(this.listOfLocations || [], x => x.id === destLocationId)
                  let getWarehouse = this.$_findValueInArray(this.listOfWarehouse || [], x => x.id === warehouseid)
                  let pickedQty = result[i].pickedorders[j] ? result[i].pickedorders[j].pickedqty : 0
                  // result[i].receivedorders[j].locationname = getLocation ? getLocation.name : ''
                  // result[i].pickedorders[j].destlocationname = getDesLocation ? getDesLocation.name : ''
                  result[i].pickedorders[j].destlocationname = result[i].adjustorder.locationname
                  result[i].pickedorders[j].pickedqty = this.$formatter.replaceDotWithComma(pickedQty)
                  result[i].receivedorders[j].warehousename = getWarehouse ? getWarehouse.name : ''
                  result[i].receivedorders[j].receivedon = this.$_filterDate(result[i].receivedorders[j].receivedon)
                }
                if (type === 'adjustment') result[i].locationid = result[i].adjustorder.locationname
                if (type === 'adjustment' || type === 'return') {
                  for (let j = 0; j < result[i].pickedorders.length; j++) {
                    let locationid = result[i].pickedorders[j].locationid
                    let getLocation = this.$_findValueInArray(this.listOfLocations || [], x => x.id === locationid)
                    result[i].pickedorders[j].locationname = getLocation ? getLocation.name : ''
                  }
                }
              }
              let itemsObj = result
              resolve(itemsObj)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    sendReport (item) {
      this.getInvoiceSettings()
        .then(() => {
          this.shareDialog = true
          this.mails = item.supplier_email
          this.orderModel = item
        })
    },
    async shareReport () {
      if (this.$refs.shareForm.validate()) {
        this.shareLoading = true
        if (!this.mails.length > 0) this.isValidEmail = true
        let getMailIDsString = this.mails
        let listOfMailIds = getMailIDsString.split(',')
        if (listOfMailIds && listOfMailIds.length > 0) {
          for (let i = 0; i < listOfMailIds.length; i++) {
            if (listOfMailIds[i]) {
              listOfMailIds[i] = listOfMailIds[i].trim()
              this.validEmail(listOfMailIds[i]) ? this.isValidEmail = false : this.isValidEmail = true
            }
          }
        }
        if (!this.isValidEmail) {
          let currentUserMail = this.$store.state.userDetails ? this.$store.state.userDetails.email : ''
          let model = { to: listOfMailIds, cc: this.isCopyToMe ? [currentUserMail] : [] }
          model.subject = this.subject || ''
          model.visiblefilename = `Ordre_${this.orderModel.number ? this.orderModel.number : ''}.pdf`
          model.body = this.body || ''
          this.$_executeApi('post', `file/generate_pdf`, { content: await this.generateReport(this.orderModel, this.isWithLocations, this.isWithPrices, true) })
            .then(async (response) => {
              let fileName = response.data
              model.filename = fileName
              if (this.orderModel.type_ref === 'supplier') {
                // upload files to local for share attachments
                const formData = new FormData()
                const files = this.filelist
                files.forEach(file => {
                  if (!file.is_sharepoint) {
                    formData.append(file.name, file)
                  } else {
                    formData.append(file.id, file)
                  }
                })
                if (files && files.length > 0) {
                  await this.$_executeApi('post', `warehouseorders/attachment_upload/${this.orderModel.id}/SUPPLIER`, formData)
                }
              }
              let url = this.orderModel.type_ref === 'supplier' ? `warehouseorders/share/${this.orderModel.id}` : 'file/share'
              this.$_executeApi('post', `${url}`, model)
                .then((response) => {
                  this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.tickets.sentSuccess') })
                  this.closeShareDialog()
                  this.$root.$emit('reloadOrderDetails')
                })
                .finally(() => {
                  this.shareLoading = false
                  this.orderModel = {}
                })
            })
            .catch((err) => {
              this.shareLoading = false
              console.log(err)
            })
        } else {
          this.shareLoading = false
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.invalidEmail') })
        }
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      }
    },
    closeShareDialog () {
      this.mails = ''
      this.shareDialog = false
      this.orderModel = {}
    },
    printProducts (item) {
      return new Promise((resolve, reject) => {
        let domToAppend = document.getElementById('noso_products')
        let customerLang = (item && item.supplier_language) ? item.supplier_language : this.$i18n.locale
        let lang = this.$i18n.messages[customerLang].message
        let headers = [
          { text: lang.warehouse.product, value: 'product' },
          { text: lang.warehouse.productName, value: 'name' },
          { text: lang.whOrder.loc, value: 'loc' },
          { text: lang.whOrder.ordQty, value: 'orderedqty' },
          { text: lang.whOrder.recQty, value: 'receivedqty' },
          { text: lang.whOrder.batch, value: 'batch' }
        ]
        let payload = { labels: { order: lang.layout.order, supplier: lang.order.supplier, noLoc: lang.whOrder.noLoc },
          values: { number: item.number, supplier: item.supplier_name } }
        this.$_executeApi('get', `warehouseorderitems/get_products_with_locations/${item.id}`)
          .then((response) => {
            if (response) {
              let result = response.data
              let transformList = { number: { list: ['orderedqty', 'receivedqty'], format: 'absoluteNumber' } }
              let modelResult = this.$_formatListModel(result, transformList)
              let content = processProductLabels(headers, modelResult, payload, domToAppend)
              resolve(content)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getInvoiceSettings () {
      return this.$_getSingleRecordHandler('invoicesettings')
        .then((result) => {
          if (result.data) this.settingsObj = result.data
        })
    },
    async donwloadPrintedProducts (item) {
      this.$_executeApi('post', `file/generate_pdf`, { visiblefilename: `${this.$t('message.warehouse.orderRepo')}_${item.number}`, content: await this.printProducts(item) })
        .then((response) => {
          let fileName = response.data
          window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
        })
    },
    /* eslint-disable */
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    }
  }
}
